class CreateImageSrc {
  constructor ({imageData, containerEl, dpi = 1}) {
    this.dpi = window.devicePixelRatio || 1
    this.containerEl = containerEl
    this.imageData = imageData
    console.log(this.imageData)
    this.imageSrc = null
    if (this.imageData) {
      this.sortSrcset()
      this.setFrame()
      this.setImageSrc()
    }
  }
  sortSrcset () {
    this.imageData.srcset.sort((a, b) => {
      return a.w - b.w
    })
  }
  setFrame () {
    // CHECK CONTAINER
    const r = this.containerEl.getBoundingClientRect()
    this.frame = {
      width: r.width,
      height: r.height,
      orientation: r.width >= r.height ? 'landscape' : 'portrait'
    }

    // ELSE SCALE AFTER VIEWPORT
  }
  setImageSrc () {
    const frameOrientation = this.frame.orientation
    const items = this.imageData.srcset.filter(item => {
      if (item.w >= this.frame.width && item.h >= this.frame.height) {
        return item
      }
    }).sort((a, b) => {
      return frameOrientation === 'landscape' ? a.w - b.w : a.h - b.h
    })
    console.log('FRAME', this.frame)
    console.log('ITEMS', items)
    this.imageSrc = items[0] || this.imageData.srcset[2]
  }
  get src () {
    return !this.imageData ? null : `${this.imageData.path}/${this.imageData.image_id}/${this.imageData.image_id}-${this.imageSrc.n}.${this.imageData.type}`
  }
}

export default CreateImageSrc



// WEBPACK FOOTER //
// ./src/modules/ModuleImage/utils/CreateImageSrc.js